import { useFormik } from 'formik';
import { FC } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import { ImagePicker } from '../../../component/imagePicker';
import { Input } from '../../../component/input';
import { AddModal } from '../../../component/modal';
import { useAddAdminMutation } from '../../../store/admin/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { addAdminValidation } from '../validation';

type IAddAdmin = {
  show?: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AddAdmin: FC<IAddAdmin> = ({ setShow }) => {
  const [addAdmin, { isLoading }] = useAddAdminMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file[0]);
  };

  const handleAdminSubmit = (values: {
    fullName: string;
    email: string;
    phone: string;
    file: File | null;
  }) => {
    if (!values.file) {
      showErrorToast('image is required');
      return;
    }
    const formData = new FormData();
    formData.append('fullName', values.fullName);
    formData.append('email', values.email);
    formData.append('phone', values.phone);
    formData.append('file', values.file);

    addAdmin(formData)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setShow(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  const { values, handleSubmit, handleChange, setFieldValue, touched, errors } =
    useFormik({
      initialValues: { fullName: '', email: '', phone: '', file: null },
      validationSchema: addAdminValidation,
      onSubmit: handleAdminSubmit
    });
  return (
    <AddModal
      title="Add admin"
      disableBtn={isLoading}
      btnTxt={isLoading ? 'Loading...' : 'Add Admin'}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
      isLoading={false}
    >
      <Container>
        <Row>
          <CustomInput
            labelText="FullName"
            value={values.fullName}
            onChange={handleChange('fullName')}
            errorMessage={touched.fullName ? errors.fullName : ''}
          />
          <CustomInput
            labelText="Email address"
            type={'email'}
            onChange={handleChange('email')}
            value={values.email}
            errorMessage={touched.email ? errors.email : ''}
          />
        </Row>
        <Row>
          <CustomInput
            labelText="Mobile number"
            onChange={handleChange('phone')}
            value={values.phone}
            errorMessage={touched.phone ? errors.phone : ''}
          />
        </Row>
        <CustomImageUpload multiple={false} onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;

  @media screen and (max-width: 500px) {
    height: calc(100vh - 225px);
    overflow-y: auto;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;
const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
